export default __webpack_public_path__ + "static/media/sophie.572a9dc4.png";